import { createFileRoute } from '@tanstack/react-router';
import { CityForm } from '../../../features/cities/components/city-form';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/cities/new')({
  staticData: { breadcrumb: 'Новый' },
  component: NewCityPage,
});

function NewCityPage() {
  return (
    <div>
      <PageHeader title="Новый город" />
      <CityForm mode="create" />
    </div>
  );
}
